// @ts-nocheck
/* eslint-disable */
import React from 'react';
import { Button, Form, Input, Message } from '@arco-design/web-react';
import md5 from 'md5';
import { useNavigate } from 'react-router-dom'; // 修改导入
import { loginPost } from '../service/login'
import './index.scss';

const FormItem = Form.Item;


function Login(props: Props) {
  const [form] = Form.useForm<{ name: string; password: string }>();
  const navigate = useNavigate(); // 使用 useNavigate

  const login = () => {
    form
      .validate()
      .then(res => {
        const { name, password } = res;
        loginPost({ username: name, password }, (dataRes: any) => {
          const { token } = dataRes || {};
          if (token) {
            Message.success("登录成功！");
            // 先清除历史token
            localStorage.removeItem("authToken")
            // 设置token
            localStorage.setItem("authToken", `Bearer ${token}`);
            // 登录成功后的跳转逻辑 跳转到根目录
            navigate('/');
          } else {
            Message.error("登录失败：" + message);
          }
        })

      })
      .catch(e => {
        console.log(e.errors);
      });
  };
  return (
    <div className="login">
      <div className="content">
        <div className="title">用户登录</div>
        <Form form={form} autoComplete="off">
          <FormItem label="用户名" field="name" rules={[{ required: true }]}>
            <Input placeholder="请输入用户名" />
          </FormItem>
          <FormItem label="密码" field="password" rules={[{ required: true }]}>
            <Input placeholder="请输入密码" type="password" />
          </FormItem>
        </Form>
        <Button
          type="primary"
          onClick={() => {
            login();
          }}
        >
          登录
        </Button>
      </div>
    </div>
  );
}

export default Login;
